import { useMutation } from '@tanstack/react-query';
import { retrieveAddress } from '../services/addressLookup';
import type { NormalisedAddress } from '../types/addressLookup.types';

// Mutation, not a query — Retrieve is the billable call and must fire once per
// selection, never re-issued by refetch-on-focus, reconnect or remount.
export const useAddressRetrieve = () =>
    useMutation<NormalisedAddress, unknown, string>({
        mutationFn: (id: string) => retrieveAddress(id),
        retry: 0,
    });
